import React, { useEffect, useState, useCallback } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Card,
  CardHeader,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useStyles } from './style';
import api from '../../services/api';
import { RecordsResponseType } from '../../@types/records';

const initialRecordsResponse: RecordsResponseType = {
  count: 0,
  next: '',
  previous: '',
  results: [],
};

const History: React.FC = () => {
  const classes = useStyles();
  const { pathId } = useParams();

  const [loading, setLoading] = useState<boolean>(true);
  const [records, setRecords] = useState<RecordsResponseType>(initialRecordsResponse);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get<RecordsResponseType>(`/api/records/record_logs/`, {
      headers: { Authorization: `Token ${localStorage.getItem('auth')}` },
      params: {
        id: pathId,
      },
    });

    setRecords(data);
    setLoading(false);
  }, [pathId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <>
          <Card>
            <CardHeader
              className={classes.cardHeader}
              title="Histórico"
              titleTypographyProps={{ style: { fontSize: 20 } }}
            />
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table}>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell className={classes.responsive}>Data e Hora</TableCell>
                    <TableCell>Endereço 1</TableCell>
                    <TableCell>Endereço 2</TableCell>
                    <TableCell className={classes.responsive}>Ativo</TableCell>
                    <TableCell>Funções</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.results.map((value) => (
                    <TableRow key={value.uuid} hover>
                      <TableCell className={classes.responsive}>
                        {`${format(
                          new Date(value.occurred_from),
                          'dd MMMM, yyyy, HH:mm',
                          {
                            locale: ptBR,
                          },
                        )}`}
                      </TableCell>
                      <TableCell width={300}>
                        {value.data.driverIncidenteDetails['Endereço 1']}
                      </TableCell>
                      <TableCell width={300}>
                        {value.data.driverIncidenteDetails['Endereço 2']}
                      </TableCell>
                      <TableCell className={classes.responsive}>
                        {value.archived ? 'Não' : 'Sim'}
                      </TableCell>
                      <TableCell className={classes.buttonsCol}>
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.button}
                        >
                          <a
                            href={`/editar/sinistro/${pathId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'black' }}
                          >
                            Editar
                          </a>
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.button}
                        >
                          <a
                            href={`/registro/sinistro/${value.uuid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'black' }}
                          >
                            Exibir
                          </a>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </>
      )}
    </>
  );
};

export default History;
